import { FC } from 'react';
import { BlockResize } from 'components/BlockResize';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { Field } from 'ui/Field';
import styles from './AdditionalMainDocument.module.scss';
import { additionalDocumentsTypes } from 'redux/employedDetail/types';

const fieldsConfig = {
  visa_type: { placeholder: 'Тип визы', width: '168px' },
  series: { placeholder: 'Серия документа', width: '168px' },
  number: { placeholder: 'Номер документа', width: '168px' },
  issue_date: { placeholder: 'Дата выдачи документа', width: '168px' },
  annotations: { placeholder: 'Примечания', width: '100%' },
  duration_of_stay: { placeholder: 'Срок пребывания (дни)', width: '168px' },
  issuer: { placeholder: 'Орган, выдавший документ', width: '100%' },
  type: { placeholder: 'Тип документа', width: '100%' },
  validity_from: { placeholder: 'Дата начала действия документа', width: '260px' },
  validity_until: { placeholder: 'Дата окончания действия документа', width: '260px' },
} as const;

const typeDocument = {
  residence_permit: 'ВНЖ(Вид на жительство)',
  migration_card: 'Миграционная карта',
  visa: 'Виза',
  temporary_residence_permit: 'РВП (разрешение на временное пребывание)',
  patent: 'Патент',
  work_permit: 'РНР (разрешение на работу)',
  employment_contract: 'Трудовой договор',
};

const typeVisa = {
  physical_visa: 'Физическая виза',
  e_visa: 'Электронная виза',
};

type FieldKey = keyof typeof fieldsConfig;

export const AdditionalMainDocument: FC<{ item: additionalDocumentsTypes }> = ({
  item,
}) => {
  const { openBlock } = useSelector((state: RootState) => state.employedsDetailSlice);

  return (
    <BlockResize open={openBlock} title='Дополнительный документ'>
      <div className={styles.root} id='mainDocAnchor'>
        <Field
          style={{ width: '100%' }}
          placeholder='Тип документа'
          title={typeDocument[item.type as keyof typeof typeDocument]}
        />
        {(Object.keys(fieldsConfig) as FieldKey[])
          .filter((key) => key !== 'type')
          .map((key) => {
            if (!item?.[key]) return null;

            const title =
              key === 'visa_type'
                ? typeVisa[item.visa_type as keyof typeof typeVisa]
                : item[key];

            return (
              <Field
                key={key}
                style={{ width: fieldsConfig[key].width }}
                placeholder={fieldsConfig[key].placeholder}
                title={title}
              />
            );
          })}
      </div>
    </BlockResize>
  );
};
